// import moment from 'moment';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { addToCart } from 'store/features/cartSlice';

const CardScheduleSessions = ({ item, pickDate, type }) => {
  const navigation = useNavigate();
  const dispatch = useDispatch();

  const goToBuy = (paramsId) => {
    navigation(`/checkout/${paramsId}`);
  };

  const handleAdd = (product) => {
    dispatch(addToCart(product));
  };

  return (
    <div className="flex flex-row items-center gap-2">
      <div className="hidden md:block font-bold text-kin-text text-base max-w-[120px]">
        9:00 AM - 12:30 PM
      </div>
      <div className="bg-white flex flex-col items-start md:flex-row md:items-center justify-between font-semibold text-kin-text rounded-xl p-4 md:py-4 md:px-6 flex-1 gap-2">
        <div className="block md:hidden font-bold text-kin-text text-base">9:00 AM - 12:30 PM</div>
        <div className="flex flex-col">
          <span className="hidden md:block text-xs font-light">3 hr 30 min</span>
          <span className="text-base font-bold">Play Session 1</span>
          <span className="block md:hidden text-xs font-light">3 hr 30 min</span>
        </div>
        {/* {type === 'cart' ? (
          <button
            onClick={() => handleAdd(item)}
            className="w-full md:w-fit bg-primary-main text-white rounded-[100px] py-2 px-3 flex justify-center items-center">
            <span className="text-xs font-semibold block">ADD TO CART</span>
          </button>
        ) : (
          <button
            onClick={() => goToBuy(item.id)}
            className="w-full md:w-fit bg-primary-main text-white rounded-[100px] py-2 px-3 flex justify-center items-center">
            <span className="text-xs font-semibold block">BUY NOW</span>
          </button>
        )} */}
      </div>
    </div>
  );
};

export default CardScheduleSessions;
